import { Injectable } from '@angular/core'
import { BaseModelService } from './base-model.service'
import { OnlineLearningRegistrationSerializer } from 'serializers'
import { OnlineLearningRegistration } from './online-learning-registration.model'
import { Constants } from 'config'

@Injectable()
export class OnlineLearningRegistrationService extends BaseModelService<OnlineLearningRegistration> {
  constructor() {
    super()

    this.configure({
      apiPath: Constants.API.PUBLIC_PATH,
      basePath:  'online_learning_registrations',
      key:       'onlineLearningRegistration',
      pluralKey: 'onlineLearningRegistrations',
      serializer: OnlineLearningRegistrationSerializer
    })
  }

  complement(registration: OnlineLearningRegistration, extantion) {
    console.log(registration, extantion);
    Object.keys(extantion).forEach(key => {
      registration.data[key] = extantion[key]
    })
    return this.save(registration)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/online-learning-regitstration.service.ts